import React, { VFC } from 'react';

import { get, sortBy } from 'lodash';

import ArticleBlock from '/components/ArticleBlock';
import { ContentColumn, StatColumn } from '/components/BlockColumns';
import { LAYOUT, useColsCollapsed } from '/components/common';
import Title from '/components/Title';
import { BlockProps, ColumnContainerJson } from '/types';

const BlockContentStat: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  blockBackgroundType,
  presentOption,
  ...props
}) => {
  const colsCollapsed = useColsCollapsed();
  const columnData = get(blockContent, 'columns.list', []);
  const layout = get(blockContent, 'columns.layout');

  // Stats first when collapsed or if wider column is to the right
  const orderedColumns =
    colsCollapsed || layout == LAYOUT.RIGHT
      ? sortBy(columnData, (column) => (column.name === 'content' ? 1 : 0))
      : columnData;

  const titleHidden = get(blockContent, 'title.hidden');
  const titleContent = get(blockContent, 'title.content');
  setAnimationComplete(animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      blockBackgroundType={blockBackgroundType}
      hideFooter={animationEnabled && !animationStep}
      presentOption={presentOption}
      titleWithinColumn
      columns={orderedColumns.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden && column.name === 'stat' && (
            <StatColumn
              background={blockBackgroundType}
              elements={column.elements}
              hide={animationEnabled && !animationStep}
            />
          )}
          {!column.hidden && column.name === 'content' && (
            <>
              {!colsCollapsed && !titleHidden && titleContent && (
                <Title content={titleContent} hidden={titleHidden} />
              )}
              <ContentColumn
                elements={column.elements}
                presentOption={presentOption}
                hide={animationEnabled && !animationStep}
              />
            </>
          )}
        </>
      ))}
    />
  );
};

BlockContentStat.displayName = 'BlockContentStat';
export default BlockContentStat;
